import Model from "~/models/_Model";
import dayjs from "dayjs";
//import Course from "./Course";

export default class TestHistory extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/courseplanner";
  }

  // Set the resource route of the model
  resource() {
    return "test-history";
  }

  relations() {
    return {
      //course_info: Course,
      //alt_course_info: Course,
    };
  }

  // Computed Attributes
  get display_test() {
    /*
    if (!this.course_info) {
      return this.course;
    }
    return `${this.course}: ${this.course_info.DESCRIPTION_CLEAN}`;
    */
   return 'Test';
  }

  get display_test_date() {
    return dayjs(this.TEST_DATE).format("MM/DD/YYYY");
  }

  get id_key() {
    return `${this.STUDENT_ID.trim()}-${this.TEST_CODE.trim()}-${
      this.TEST_FORM
    }-${this.TEST_KEY}-${this.TEST_LEVEL.trim()}-${this.TEST_DATE}`;
  }

  get sort_key() {
    return this.request_type == "regular"
      ? `1-${this.course.trim()}`
      : this.request_type == "alternate"
      ? `2-${this.alt_course_priority}-${this.course.trim()}`
      : `3-${this.course.trim()}`;
  }

  getScoresForSubtest(subtestId) {
    if (!this.stu_subtest) {
      return [];
    }
    subtestId = subtestId.trim().toLowerCase();
    return this.stu_subtest
      .filter(
        (t) => t.SUBTEST.trim().toLowerCase().localeCompare(subtestId) == 0
      )
      .sort((a, b) => a.score_info.SCORE_ORDER - b.score_info.SCORE_ORDER);
  }
}
